<template>
    <paper class="physical-storage">
        <div class="storage" v-loading="loading">
            <div class="storage-head">
                <div class="storage-button">
                    <div class="button-left">
                        <div class="storage-input">
                            <el-input class="input" v-model="form.whCode" clearable placeholder="仓库编码"></el-input>
                            <el-input class="input" v-model="form.whName" clearable placeholder="仓库名称"></el-input>
                            <MSelect
                                class="input"
                                placeholder="仓库状态"
                                :option-num="'SRM_WH_STATUS'"
                                :value="form.whStatus"
                                :filterable="true"
                                @input="getwhStatus"></MSelect>
                            <MSelect
                                class="input"
                                placeholder="产权属性"
                                multiple
                                size="mini"
                                :option-num="'SYS_PROPERTY_RIGHTS'"
                                collapse-tags
                                :value="form.propertyTypeList"
                                :filterable="true"
                                @input="getPropertyType"></MSelect>
                            <mInput
                                class="input"
                                :params="companyData"
                                placeholder="分公司"
                                @getAdvanceValue="getcompanyCode"
                                :m-value="form.companyName"></mInput>
                            <el-button class="input-btn bigData-btn-search" type="primary" @click="seachFn">
                                查询
                            </el-button>
                            <el-popover placement="bottom" width="1240" trigger="manual" v-model="visible">
                                <el-form
                                    ref="form"
                                    class="popover-wrapper-form-physical-warehouse"
                                    :model="form"
                                    label-width="150px">
                                    <el-form-item class="item" label="仓库编码">
                                        <el-input v-model="form.whCode" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item class="item" label="仓库名称">
                                        <el-input v-model="form.whName" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item class="item" label="产权人">
                                        <el-input v-model="form.propertyOwner" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item class="item" label="仓库状态">
                                        <MSelect
                                            :option-num="'SRM_WH_STATUS'"
                                            :value="form.whStatus"
                                            :filterable="true"
                                            @input="getwhStatus"></MSelect>
                                    </el-form-item>
                                    <el-form-item class="item" label="产权属性">
                                        <MSelect
                                            multiple
                                            collapse-tags
                                            size="mini"
                                            :option-num="'SYS_PROPERTY_RIGHTS'"
                                            :value="form.propertyTypeList"
                                            :filterable="true"
                                            @input="getPropertyType"></MSelect>
                                    </el-form-item>
                                    <el-form-item class="item" label="仓库类型">
                                        <MSelect
                                            :option-num="'SYS_SU_WH_TYPE'"
                                            :value="form.whType"
                                            :filterable="true"
                                            @input="getwhType"></MSelect>
                                    </el-form-item>
                                    <el-form-item class="item" label="消防验收">
                                        <MSelect
                                            :option-num="'SYS_SU_FIRE_INSPECTION'"
                                            :value="form.fireInspection"
                                            :filterable="true"
                                            @input="getFireInspection"></MSelect>
                                    </el-form-item>
                                    <el-form-item class="item" label="月台">
                                        <MSelect
                                            :option-num="'SYS_SU_PLATFORM'"
                                            :value="form.platform"
                                            :filterable="true"
                                            @input="getPlatform"></MSelect>
                                    </el-form-item>
                                    <el-form-item class="item" label="雨棚">
                                        <MSelect
                                            :option-num="'SYS_SU_CANOPY'"
                                            :value="form.canopy"
                                            :filterable="true"
                                            @input="getCanopy"></MSelect>
                                    </el-form-item>
                                    <el-form-item class="item" label="合同状态">
                                        <MSelect
                                            :option-num="'SYS_CONTRACT_WH_STATUS'"
                                            :value="form.contractStatus"
                                            :filterable="true"
                                            @input="getcontractStatus"></MSelect>
                                    </el-form-item>
                                    <el-form-item class="item" label="分公司">
                                        <mInput
                                            :params="companyData"
                                            @getAdvanceValue="getcompanyCode"
                                            :m-value="form.companyName"></mInput>
                                    </el-form-item>
                                    <el-form-item class="item" label="城市">
                                        <mInput
                                            :params="cityData"
                                            @getAdvanceValue="getcityCode"
                                            :m-value="form.cityName"></mInput>
                                    </el-form-item>
                                </el-form>
                                <el-button
                                    class="popover-btn-physical-warehouse"
                                    type="primary"
                                    @click="popoverSeachFn">
                                    搜索
                                </el-button>
                                <el-button slot="reference" @click="visible = !visible">高级</el-button>
                            </el-popover>
                            <div class="search-set-back" v-show="visible" @click.self="visible = !visible"></div>
                        </div>
                    </div>
                    <div class="button-right">
                        <el-tooltip effect="dark" content="新增" placement="bottom" v-has="'04000062'">
                            <el-button
                                class="bigData-btn-add"
                                type="primary"
                                size="mini"
                                icon="el-icon-plus"
                                @click="addTemplate"></el-button>
                        </el-tooltip>
                        <el-tooltip effect="dark" content="导出" placement="bottom">
                            <el-button
                                :loading="expLoading"
                                size="mini"
                                icon="el-icon-download"
                                @click="handleExport"
                            ></el-button>
                        </el-tooltip>
                        <el-tooltip effect="dark" content="列配置" placement="bottom" class="tooltip" v-has="'02020003'">
                            <el-button icon="el-icon-setting" size="mini" @click="colDispose"></el-button>
                        </el-tooltip>
                    </div>
                </div>
            </div>
            <div class="storage-table">
                <el-table
                    border
                    :data="tableData"
                    height="30"
                    @selection-change="handleSelectionChange"
                    @row-dblclick="handleDblclick">
                    <el-table-column type="selection" width="40"></el-table-column>
                    <el-table-column
                        v-for="(item, index) in columnsList"
                        :key="index"
                        :prop="item.prop"
                        :label="item.label"
                        :width="item.width"
                        :fixed="item.fixed"
                        :show-overflow-tooltip="item.showOverflowTooltip">
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        label="操作"
                        width="160">
                        <template slot-scope="scope">
                            <el-button
                                @click="handleShowContract(scope.row)"
                                type="text"
                                size="small"
                            >所属合同</el-button>
                            <el-button
                                @click="handleBelong(scope.row)"
                                type="text"
                                size="small"
                            >所属供应商</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="physical-storage-footer">
                <!-- <m-page ref="page"
                class="m-page"
                :current-page="form.pageNo"
                :pageData="{ 'layout': 'total, sizes, prev, pager, next, jumper', 'pageSize': 10 }"
                :total="totalCount"
                @on-page-change="handleCurrentChange"
                @on-size-change="handleSizeChange">
        </m-page> -->
                <div>
                    <el-button class="bigData-btn-map" type="primary" @click="openMap">地图</el-button>
                    <el-button class="bigData-btn-setAdd" type="primary" @click="setStorageStatus('0')">
                        设置为新增状态
                    </el-button>
                    <el-button class="bigData-btn-setStop" type="primary" @click="setStorageStatus('2')">
                        设置为停用状态
                    </el-button>
                    <el-button v-if="exportVisible" type="primary" :loading="fcExpLoading" @click="handleFireCtlExport">
                        消防分区导出
                    </el-button>
                </div>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.pageNo"
                    :page-sizes="[10, 20, 30, 50, 100]"
                    :page-size="form.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount"></el-pagination>
            </div>
        </div>
        <el-dialog :visible.sync="mapShow" title="物理仓地图" :close-on-click-modal="false" @close="mapShow = false">
            <storage-map :storage-position-arr="storagePositionArr" v-if="mapShow"></storage-map>
        </el-dialog>

        <el-dialog width="800px" :visible.sync="contractShow" title="所属合同" :close-on-click-modal="false" @close="contractShow = false">
            <el-table
                :data="contractList"
                v-loading="contractLoading"
                border
                style="width: 100%">
                <el-table-column
                    prop="contractCode"
                    label="单据编码"/>
                <el-table-column
                    prop="contractStatus"
                    label="合同状态"/>
            </el-table>
            <el-pagination
                    style="text-align: right;"
                    @size-change="contractSizeChange"
                    @current-change="contractCurrentChange"
                    :current-page="contractPageNo"
                    :page-sizes="[10, 20, 30, 50, 100]"
                    :page-size="contractPageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="contractTotalCount"></el-pagination>
        </el-dialog>
        <BelongSupDialog ref="bsRef" />

        <el-dialog :visible.sync="showModal" title="列配置">
            <configuration
                :checkedList="checkedList"
                :selectAllColumns="selectAllColumns"
                ref="dialog"
                @getTableConfigList="getTableConfigList"
                @tableConfigClose="tableConfigClose"
                :columnNum="columnNum"
            ></configuration>
        </el-dialog>
    </paper>
</template>
<script>
import { getList } from '../../../../../api/annoMana.js';
import configuration from '@/components/otpPanel/configuration-list';
import '@/styles/fonts/iconfont.js'
import { storageList, exportPhysicsWarehouses, setWhStatus, viewAddressMap, exportWarehouse, contractWarehouseInfoQuery } from '../../../../../api/physicalStorage.js'
import MSelect from '@/components/lots/otpSelect2'
import paper from '@/components/core/paper/Paper'
import mInput from '@/components/lots/otpAdvance'
import BelongSupDialog from './BelongSupDialog.vue'
import { mapGetters } from 'vuex'
import { dictWithUrl } from '@/components/lots/api'
import storageMap from './storageMap.vue'
import { WH_STATUS } from './initData.js'
const tableConfig = [
    { prop: 'whCode', label: '仓库编码', width: '120', showOverflowTooltip: true, fixed: 'left' },
    { prop: 'whName', label: '仓库名称', width: '120', showOverflowTooltip: true, fixed: false },
    { prop: 'companyName', label: '分公司', width: '120', showOverflowTooltip: true, fixed: false },
    { prop: 'cityName', label: '城市', width: '120', showOverflowTooltip: true, fixed: false },
    { prop: 'whAddress', label: '仓库地址', width: '320', showOverflowTooltip: true, fixed: false },
    { prop: 'whStatusText', label: '仓库状态', width: '80', showOverflowTooltip: true, fixed: false },
    { prop: 'contractStatusText', label: '合同状态', width: '80', showOverflowTooltip: true, fixed: false },
    { prop: 'propertyType', label: '产权属性', width: '100', showOverflowTooltip: true, fixed: false },
    { prop: 'propertyOwner', label: '产权人', width: '100', showOverflowTooltip: true, fixed: false },
    { prop: 'whTypeText', label: '仓库类型', width: '100', showOverflowTooltip: true, fixed: false },
    { prop: 'fireInspection', label: '消防验收', width: '100', showOverflowTooltip: true, fixed: false },
    { prop: 'canopyText', label: '雨棚', width: '90', showOverflowTooltip: true, fixed: false },
    { prop: 'platformText', label: '月台', width: '120', showOverflowTooltip: true, fixed: false },
    // { prop: 'factoryFlagText', label: '是否地产商', width: '120', showOverflowTooltip: true, fixed: false },
    { prop: 'factorySignText', label: '地产商简称', width: '120', showOverflowTooltip: true, fixed: false },
    { prop: 'warehouseLevelText', label: '仓库等级', width: '120', showOverflowTooltip: true, fixed: false },
    { prop: 'whSquare', label: '仓库建筑面积（㎡）', width: '140', showOverflowTooltip: true, fixed: false },
    { prop: 'usableArea', label: '安得已租赁面积（㎡）', width: '160', showOverflowTooltip: true, fixed: false },
    { prop: 'rentableArea', label: '剩余可租面积（㎡）', width: '140', showOverflowTooltip: true, fixed: false },
    { prop: 'createUserName', label: '创建人', width: '120', showOverflowTooltip: true, fixed: false },
    { prop: 'createTime', label: '创建时间', width: '150', showOverflowTooltip: true, fixed: false },
    { prop: 'updateUserName', label: '修改人', width: '120', showOverflowTooltip: true, fixed: false },
    { prop: 'updateTime', label: '修改时间', width: '150', showOverflowTooltip: true, fixed: false },
]
const APPROVE_STATUS_DRAEFT = '1' // 物理仓审批状态 => 草稿
const APPROVE_STATUS_CHECK = '2' // 物理仓审批状态 => 审批中
const APPROVE_STATUS_REJECT = '4' // 物理仓审批状态 => 驳回
const WH_STAUS_FAIR = '1' // 物理仓状态 => 合格
export default {
    name: 'physicalStorage',
    components: { paper, mInput, MSelect, storageMap, BelongSupDialog, configuration },
    data() {
        return {
            dict: {},
            whCode: '',
            contractLoading: false,
            contractPageNo: 1,
            contractPageSize: 10,
            contractTotalCount: 0,
            contractShow: false,
            contractList: [],
            columnNum: 100,
            resourceCode: '',
            showModal: false,
            checkedList: '',
            columnsList: JSON.parse(JSON.stringify(tableConfig)),
            selectAllColumns: JSON.parse(JSON.stringify(tableConfig)),
            form: {
                propertyTypeList: [],
                whCode: '',
                whName: '',
                whStatus: '',
                whType: '',
                fireInspection: '',
                platform: '',
                canopy: '',
                companyCode: '',
                companyName: '',
                cityCode: '',
                cityName: '',
                pageNo: 1,
                pageSize: 10,
            },
            totalCount: 1,
            tableData: [],
            selectArr: [],
            visible: false,
            companyData: {
                value: 'companyName',
                advanceConfig: [
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
                advanceUrl: '/esCompany/popCompany',
                cbParams: ['companyCode#companyCode', 'companyNameCn#companyName'],
                name: '分公司',
                tableConfig: [
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
            },
            cityData: {
                value: 'ebplNameCn',
                name: '城市',
                advanceConfig: [
                    { prop: 'ebplNameCn', value: '中文名称' },
                    { prop: 'ebplCode', value: '代码' },
                ],
                tableConfig: [
                    { prop: 'ebplCode', value: '代码' },
                    { prop: 'ebplNameCn', value: '中文名称' },
                    { prop: 'ebplNameEn', value: '英文名称' },
                ],
                advanceUrl: '/searchEbPlacePage?ebplType=PLACE_CITY&ebplIsAble=ENABLE',
                cbParams: ['ebplCode#ebplCode', 'ebplNameCn#ebplNameCn'],
            },
            tableConfig: tableConfig,
            storagePositionArr: [],
            mapShow: false,
            loading: false,
            oldForm: {},
            isUserRights: false, // 校验用户权限
            exportVisible: false,
            reportCode: 'SRM_PSC_STORAGE_EXPORT',
            expLoading: false, // 查询页导出
            fcExpLoading: false, // 消防分区导出
        }
    },
    computed: {
        ...mapGetters(['menus', 'currentTenant', 'applicationCode', 'btnPermissions']),
    },
    created() {
        this.isUserRights = this.btnPermissions.indexOf('04000302') !== -1 || this.isUserRights
    },
    mounted() {
        this.loadData(this.form)
        this.setConfigColumn();
    },
    methods: {
        handleShowContract(row){
            this.contractShow = true
            this.whCode = row.whCode
            this.contractPageNo = 1
            this.getContractList()
        },
        getContractList() {
            this.contractLoading = true
            contractWarehouseInfoQuery({whCode: this.whCode, pageNo: this.contractPageNo, pageSize: this.contractPageSize}).then(res => {
                if(res && +res.code === 0){
                    this.contractList = (res.data.list || []).map(v => {
                        return {
                            ...v,
                            contractStatus: this.dict['SRM_CONTRACT_STATUS'][v.contractStatus]
                        }
                    })
                    this.contractTotalCount = res.data.totalCount
                }
            }).finally(() => {
                this.contractLoading = false
            })
        },
        colDispose() {
            this.showModal = true;
        },
        setConfigColumn() {
            const menu = { subResources: JSON.parse(JSON.stringify(this.menus)) };
            this.deepMenu(menu);
            const pramas = {
                moduleCode: this.resourceCode,
                subjectType: 'physical-storage-251204'
            };
            getList.get(pramas).then(res => {
                if (res.data && res.data.configNameCn) {
                    const datas = res.data.configNameCn.split(',');
                    const columnsList = [];
                    datas.map(title => {
                        this.selectAllColumns.map(data => {
                            if (data.label === title) {
                                columnsList.push(data);
                            }
                        });
                    });
                    this.columnsList = columnsList;
                    const arr = [];
                    this.columnsList.forEach(el => {
                        arr.push(el.label);
                    });
                    this.checkedList = arr.join(',');
                }
            });
        },
        deepMenuFor(childrens) {
            for (let i = 0; i < childrens.length; i++) {
                if (childrens[i].frontUrl === this.$route.path || (childrens[i].frontUrl === '/index' && this.$route.path === '/')) {
                    this.resourceCode = childrens[i].resourceCode;
                } else {
                    this.deepMenu(childrens[i]);
                }
            }
        },
        deepMenu(node) {
            const nodes = [];
            if (node) {
                nodes.push(node);
                const childrens = node.subResources;
                if (childrens) {
                    this.deepMenuFor(childrens);
                }
            }
        },
        tableConfigClose() {
            this.showModal = false;
        },
        getTableConfigList(tabelConfigList, tabelConfigName) {
            this.showModal = false;
            const pramas = {
                configName: tabelConfigName,
                configNameCn: tabelConfigList,
                subjectType: 'physical-storage',
                moduleCode: this.resourceCode
            };
            getList.post(pramas).then(() => {});
            const datas = tabelConfigList.split(',');
            const columnsList = [];
            datas.map(title => {
                this.selectAllColumns.map(data => {
                    if (data.label === title) {
                        columnsList.push(data);
                    }
                });
            });
            this.columnsList = columnsList;
        },
        async loadData(serachObj) {
            const params = {
                ...serachObj,
                needAuth: true
            }
            const res = await storageList(params)
            if (res && res.code === '0') {
                this.conversionData(res.data.list)
                this.totalCount = res.data.totalCount
                this.exportVisible = serachObj.whStatus === WH_STATUS.QUALIFIED
            }
            this.oldForm = JSON.parse(JSON.stringify(serachObj))

            const arr = [];
            this.columnsList.forEach(el => {
                arr.push(el.label);
            });
            this.checkedList = arr.join(',');
        },
        conversionData(list) {
            // -------------获取物流状态字典值-------------
            dictWithUrl(
                'SRM_WH_STATUS,SYS_SU_WH_TYPE,SYS_SU_PLATFORM,SYS_SU_CANOPY,SYS_PROPERTY_RIGHTS,SYS_SU_FIRE_INSPECTION,' +
                    'SYS_CONTRACT_WH_STATUS,SRM_YES_NO,SRM_WAREHOUSE_FACTORY_SIGN,SRM_REGISTER_WAREHOUSE_LEVEL,SRM_CONTRACT_STATUS'
            ).then(res => {
                if (res && res.code === '0') {
                    this.dict = res.data
                    list.map(el => {
                        el.whStatusText = res.data['SRM_WH_STATUS'][el.whStatus]
                        el.whTypeText = res.data['SYS_SU_WH_TYPE'][el.whType]
                        el.platformText = res.data['SYS_SU_PLATFORM'][el.platform]
                        el.canopyText = res.data['SYS_SU_CANOPY'][el.canopy]
                        el.propertyType = res.data['SYS_PROPERTY_RIGHTS'][el.propertyType]
                        el.fireInspection = res.data['SYS_SU_FIRE_INSPECTION'][el.fireInspection]
                        el.contractStatusText = res.data['SYS_CONTRACT_WH_STATUS'][el.contractStatus]
                        el.factoryFlagText = res.data['SRM_YES_NO'][el.factoryFlag]
                        el.factorySignText = res.data['SRM_WAREHOUSE_FACTORY_SIGN'][el.factorySign]
                        el.warehouseLevelText = res.data['SRM_REGISTER_WAREHOUSE_LEVEL'][el.warehouseLevel]
                        return el
                    })
                    this.tableData = list
                }
            })
        },
        getParams() {
            const obj = {}
            obj.whCode = this.form.whCode
            obj.whName = this.form.whName
            obj.whStatus = this.form.whStatus
            obj.propertyTypeList = this.form.propertyTypeList
            obj.companyCode = this.form.companyCode
            obj.companyName = this.form.companyName
            obj.pageNo = this.form.pageNo
            obj.pageSize = this.form.pageSize
            return obj
        },
        // 查询
        seachFn() {
            this.form.pageNo = 1
            this.form.pageSize = 10
            this.loadData(this.getParams())
        },
        // 高级搜索
        popoverSeachFn() {
            this.form.pageNo = 1
            this.form.pageSize = 10
            this.loadData(this.form)
            this.visible = !this.visible
        },
        // 新增
        addTemplate() {
            this.$router.push({
                path: '/addPhysicalStorage',
                name: 'addPhysicalStorage',
                query: {
                    whCode: '',
                },
            })
        },
        handleSelectionChange(val) {
            this.selectArr = val
        },
        getcompanyCode(data) {
            this.form.companyCode = data.companyCode
            this.form.companyName = data.companyName
        },
        getcityCode(data) {
            this.form.cityCode = data.ebplCode
            this.form.cityName = data.ebplNameCn
        },
        getwhType(val) {
            this.form.whType = val
        },
        getFireInspection(val) {
            this.form.fireInspection = val
        },
        getwhStatus(val) {
            this.form.whStatus = val
        },
        getPropertyType(val) {
            this.form.propertyTypeList = val
        },
        getPlatform(val) {
            this.form.platform = val
        },
        getCanopy(val) {
            this.form.canopy = val
        },
        getcontractStatus(val) {
            this.form.contractStatus = val
        },
        contractSizeChange(val) {
            this.contractPageNo = 1
            this.contractPageSize = val
            this.getContractList()
        },
        handleSizeChange(val) {
            this.form.pageSize = val
            this.loadData(this.form)
        },
        contractCurrentChange(val) {
            this.contractPageNo = val
            this.getContractList()
        },
        handleCurrentChange(val) {
            this.form.pageNo = val
            this.loadData(this.form)
        },
        handleDblclick(row) {
            this.$router.push({
                path: '/addPhysicalStorage',
                name: 'addPhysicalStorage',
                query: {
                    id: row.id,
                    whCode: row.whCode,
                },
            })
        },
        async setStorageStatus(val) {
            const validIdArr = []
            const invalidIdArr = []
            const statusFairArr = []
            this.selectArr.map(ele => {
                if (
                    ele.approveStatus === APPROVE_STATUS_DRAEFT
                    || ele.approveStatus === APPROVE_STATUS_CHECK
                    || ele.approveStatus === APPROVE_STATUS_REJECT
                ) {
                    invalidIdArr.push(ele.whName)
                } else {
                    if (ele.whStatus === WH_STAUS_FAIR && !this.isUserRights) statusFairArr.push(ele.whName)
                    validIdArr.push(ele.id)
                }
            })
            if (!this.selectArr.length) {
                return this.$message.error('请选择仓库')
            }
            if (invalidIdArr.length) {
                const msg = invalidIdArr.join(',')
                return this.$message.error(`${msg}流程审批中不能操作，请完结流程再操作!`)
            }
            if (statusFairArr.length) {
                return this.$message.error(`非特权人无法修改合格仓库`)
            }
            const prams = {
                warehouseIds: validIdArr.join(','),
                whStatus: val,
            }
            try {
                await setWhStatus(prams)
                await this.loadData(this.form)
                this.$message.success('操作成功')
            } catch (e) {
                this.$message.error('操作失败')
            }
        },
        async openMap() {
            this.loading = true
            const addressArr = []
            this.selectArr.map(ele => {
                addressArr.push({
                    addressCode: ele.addressCode,
                    whName: ele.whName,
                })
            })
            // if (!addressArr.length) {
            //     this.loading = false;
            //     return this.$message.error('请选择仓库');
            // }
            try {
                const res = await viewAddressMap({ ...this.oldForm, viewMapList: addressArr })
                this.storagePositionArr = res.data
                this.mapShow = true
                this.loading = false
            } catch (e) {
                this.loading = false
                this.$message.error('操作失败')
            }
        },
        handleExport() {
            const params = { ...this.form }
            delete params.pageNo
            delete params.pageSize
            // 以下参数要求必传
            params.orderBy = 'create_time'
            params.orderByType = 'desc'
            this.expLoading = true
            exportPhysicsWarehouses(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(res.data || '正在导出，请留意右上角文件中心下载文件！')
                    }
                })
                .finally(() => {
                    this.expLoading = false
                })
        },
        handleFireCtlExport() {
            const params = { ...this.form }
            delete params.pageNo
            delete params.pageSize
            this.fcExpLoading = true
            exportWarehouse(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('导出成功!')
                        const a = document.createElement('a')
                        a.href = res.data.downUrl
                        a.download = res.data.localFileName
                        a.click()
                    }
                })
                .finally(() => {
                    this.fcExpLoading = false
                })
        },
        handleBelong(row) {
            this.$refs.bsRef.open(row)
        },
    },
}
</script>
<style lang="less">
.physical-storage {
    margin: 7px;
    height: calc(100vh - 57px);
    min-width: 1250px;

    .storage {
        .storage-button {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .storage-input {
            display: flex;
            margin-top: 10px;
        }

        .input-btn {
            margin-right: 10px;
        }

        .input {
            margin-right: 10px;
            width: 180px;
        }

        .el-form-item__content .el-input-group {
            margin-top: 5px;
        }

        .storage-table {
            margin-top: 10px;
        }

        .el-table {
            min-height: calc(~'100vh - 190px');
            max-height: calc(~'100vh - 190px');
        }

        .el-table__body-wrapper {
            min-height: calc(~'100vh - 226px');
            max-height: calc(~'100vh - 226px');
        }

        .el-table--border {
            border: 1px solid #ebeef5;
        }

        .search-set-back {
            position: fixed;
            inset: 0;
            z-index: 1000;
            overflow: auto;
            margin: 0;
        }
    }

    .m-page {
        margin-top: 20px;
    }

    .icon {
        overflow: hidden;
        width: 1em;
        height: 1em;
        font-size: 28px;
        vertical-align: -0.15em;
        fill: currentcolor;
        cursor: pointer;
    }

    .button-right {
        height: 38px;
        line-height: 45px;
    }
}

.popover-wrapper-form-physical-warehouse {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .el-form-item {
        margin-bottom: 5px;
        width: 30%;
        height: 35px;

        .el-form-item__content .el-input-group {
            vertical-align: middle;
        }
    }
}

.popover-btn-physical-warehouse {
    float: right;
}

.physical-storage-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>
